import { sanitizeUrl } from '#pplx/frontend/common/files/urls.js';
import { invariant } from '#pplx/frontend/common/invariant.js';
import { COMET_EXTERNAL_PROTOCOL, PERPLEXITY_APP_PROTOCOL, PERPLEXITY_COMPUTER_PROTOCOL, PERPLEXITY_DESKTOP_BETA_PROTOCOL, PERPLEXITY_DESKTOP_PROTOCOL, } from '#pplx/frontend/common/protocols.js';
const ALLOWED_PROTOCOLS = new Set([
    COMET_EXTERNAL_PROTOCOL,
    PERPLEXITY_APP_PROTOCOL,
    PERPLEXITY_COMPUTER_PROTOCOL,
    PERPLEXITY_DESKTOP_PROTOCOL,
    PERPLEXITY_DESKTOP_BETA_PROTOCOL,
    'http:',
    'https:',
    'mailto:',
    'tel:',
    'sms:',
    'geo:',
]);
/**
 * Redirects the window to the given URL.
 * We only allow HTTP, HTTPS & Comet External protocols to prevent XSS.
 * @param url - The URL to redirect to.
 */
export function sanitizedRedirectWindow(url) {
    const sanitizedUrl = sanitizeUrl(url);
    invariant(ALLOWED_PROTOCOLS.has(sanitizedUrl.protocol), 'Redirect URL must be allowed protocols');
    // ast-grep-ignore: no-window-location-href
    window.location.href = sanitizedUrl.toString();
}
/**
 * Opens a URL in a new window after validating that the protocol is safe.
 * @param url - The URL to open.
 */
export function sanitizedOpenWindow(url) {
    const sanitizedUrl = sanitizeUrl(url);
    invariant(ALLOWED_PROTOCOLS.has(sanitizedUrl.protocol), 'Open URL must be allowed protocols');
    window.open(sanitizedUrl.toString(), '_blank', 'noopener,noreferrer');
}
//# sourceMappingURL=sanitizedRedirectWindow.js.map